import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { VIEW_CLAIM_STATUS_GTM, VIEW_CLAIM_STATUS_MP } from "modules/common/trackingConsts";
import { useEffect, useState } from "react";
import config from "config/config";
import getPageUrl from "utils/getPageUrl";
import NavButton from "./NavButton";

const WEBAPP_SIGNED_IN_ENDPOINT = `${config.webappUrl}/api/users/check_signed_in`;

const isUserSignedIn = async () => {
  try {
    const response = await fetch(WEBAPP_SIGNED_IN_ENDPOINT, {
      credentials: "include",
    });
    const { signed_in: signedIn } = await response.json();
    return signedIn;
  } catch {
    return false;
  }
};

const CheckCompensationButton = () => {
  const language = useLanguage();
  const translations = useTranslations();

  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    isUserSignedIn().then((response) => setIsSignedIn(response));
  }, []);

  return (
    <NavButton
      href={isSignedIn ? `${config.webappUrl}/claims-and-flights` : getPageUrl(language, "webappNewClaim")}
      title={isSignedIn ? translations("view_claim_status") : translations("check_compensation")}
      trackingEvents={{ gtmEvent: VIEW_CLAIM_STATUS_GTM, mixpanelEvent: VIEW_CLAIM_STATUS_MP }}
      dataTestId="top-navbar-view-status-button"
    />
  );
};

export default CheckCompensationButton;
